import { defineMessages } from 'react-intl';

const messages = defineMessages({
  sectionTitle: {
    description: 'Label for the title representing the shipment items section',
    defaultMessage: 'Shipment Items',
    id: 'XxsZue',
  },
  sectionAriaLabel: {
    defaultMessage: 'Shipment Items expander section',
    description: 'Aria label for the expandable Shipment Items section',
    id: 'QAAx0k',
  },
  splitButton: {
    description: 'Split button cta title',
    defaultMessage: '{icon} Split Ship',
    id: 'mMklOy',
  },
  editButton: {
    description: 'Button to launch modal to edit items in the current shipment',
    defaultMessage: '{icon} Edit',
    id: 'AcHSoP',
  },
  removeShipmentButton: {
    description: 'Button to launch modal to remove shipment from current order',
    defaultMessage: 'Remove Shipment',
    id: 'dq0whi',
  },
  removeShipmentBanner: {
    description:
      'Information banner message informing the user there are no items from a specified order in this shipment, and suggesting the order can be removed from the current order.',
    defaultMessage:
      'No items from {orderNumber} are in this shipment. Click <b>Remove Shipment</b> to remove {orderNumber} from the current order.',
    id: 'VL2105',
  },
  verified: {
    description: 'Label representing when a shipment has been verified through the scan verification process',
    defaultMessage: 'Scan Verified',
    id: '5/xG9J',
  },
});

export default messages;
